export default "__VITE_ASSET__gkzEjbA3__"